module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_j_albino.68cb8a4d.png";